import { ArrowLeft } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { appPaths } from "../Routes";
import { useAddDataSource } from "../api/data-sources";
import { AddDataSourceDto } from "../api/models/DataSource";
import AddDataSourceForm from "../components/AddDataSourceForm/AddDataSourceForm";
import { AddDataSourceFormValues } from "../components/AddDataSourceForm/AddDataSourceFormValues";
import ContentContainer from "../components/ContentContainer";
import IconButton from "../components/IconButton";
import MainLayout from "../components/MainLayout/MainLayout";
import Separator from "../components/Separator";
import Typography from "../components/Typography";
import { errorToast, successToast } from "../toast";

const DataSourceAddPage = () => {
    const navigate = useNavigate();

    const [request, isAddingDataSource] = useAddDataSource();

    const handleSubmit = async (values: AddDataSourceFormValues) => {
        const dto: AddDataSourceDto = {
            ...values,
        };

        const response = await request(dto);

        if (!response.success) {
            errorToast(
                "There was a problem adding data source - please try again"
            );
            return;
        }

        successToast("Data source added");
        redirectToDataSources();
    };

    const redirectToDataSources = () => navigate(appPaths.dataSources);

    return (
        <MainLayout>
            <ContentContainer className="pt-14 pb-11">
                <div className="flex flex-col gap-6 sm:gap-0 sm:flex-row items-center pb-5">
                    <div className="flex items-center">
                        <IconButton
                            label="Back"
                            icon={ArrowLeft}
                            iconSize="large"
                            className="mr-3"
                            onClick={() => window.history.back()}
                        />
                        <Typography variant="headline-small" component="h1">
                            Add data source
                        </Typography>
                    </div>
                </div>
                <Separator className="mb-8" />
                <AddDataSourceForm
                    onSubmit={handleSubmit}
                    isSubmitting={isAddingDataSource}
                    onCancel={redirectToDataSources}
                />
            </ContentContainer>
        </MainLayout>
    );
};

export default DataSourceAddPage;
